import type { CreditV1PeriodProduct } from '@/app/types';

export type ClawPassPlanType = 'claw_pass_basic' | 'claw_pass_pro';

export type ClawProductType = Extract<
  NonNullable<CreditV1PeriodProduct['product_type']>,
  'claw_pass' | 'claw_pass_bundle'
>;

export interface ClawPassRightEntry {
  primaryKey: string;
  secondaryKeys?: string[];
  // 在该条目前插入一条分隔线（用于 bundle 中分隔 plan 权益与 bundle 扩展权益）
  divider?: boolean;
}

export const CLAW_PASS_RIGHTS: ClawPassRightEntry[] = [
  { primaryKey: 'claw_highQualityVideoGeneration', secondaryKeys: ['claw_highQualityVideoGenerationDesc'] },
  { primaryKey: 'claw_conversationalCreation', secondaryKeys: ['claw_conversationalCreationDesc'] },
  { primaryKey: 'claw_agentAutomation', secondaryKeys: ['claw_agentAutomationDesc'] },
  {
    primaryKey: 'claw_flexibleVideoModelSelection',
    secondaryKeys: ['claw_flexibleVideoModelSelectionDesc_limit', 'claw_flexibleVideoModelSelectionDesc'],
  },
  { primaryKey: 'claw_imageGeneration', secondaryKeys: ['claw_planImageModels'] },
  { primaryKey: 'claw_aiAutoEditing' },
];

export const CLAW_PASS_BUNDLE_RIGHTS: ClawPassRightEntry[] = [
  { primaryKey: 'claw_highQualityVideoGeneration', secondaryKeys: ['claw_highQualityVideoGenerationDesc'] },
  { primaryKey: 'claw_conversationalCreation', secondaryKeys: ['claw_conversationalCreationDesc'] },
  { primaryKey: 'claw_agentAutomation', secondaryKeys: ['claw_agentAutomationDesc'] },
  {
    primaryKey: 'claw_flexibleVideoModelSelection',
    secondaryKeys: ['claw_flexibleVideoModelSelectionDesc_limit', 'claw_flexibleVideoModelSelectionDesc'],
  },
  { primaryKey: 'claw_imageGeneration', secondaryKeys: ['claw_planImageModels'] },
  { primaryKey: 'claw_aiAutoEditing' },
  {
    primaryKey: 'claw_includesAllPlanBenefits',
    secondaryKeys: ['claw_monthlyCredits', 'claw_creditsPurchaseDiscount', 'claw_fastLaneGeneration'],
    divider: true,
  },
];
